export const headers_module_calibration = [
  { label: "Serial Number", key: "serialNumber" },
  { label: "Pass", key: "pass" },
  { label: "Error", key: "errorNumber" },
  { label: "Debug", key: "debug" },
  { label: "App Version", key: "appVersion" },
  {
    label: "User",
    key: "username",
  },
  // FROM UPSTREAM
  { label: "Sens B2B CH1", key: "usSenInputCh1" },
  { label: "Sens B2B CH2", key: "usSenInputCh2" },
  { label: "Sens B2B CH3", key: "usSenInputCh3" },
  { label: "Sens B2B CH4", key: "usSenInputCh4" },
  { label: "OPP CH1", key: "dispPenCh1" },
  { label: "OPP CH2", key: "dispPenCh2" },
  { label: "OPP CH3", key: "dispPenCh3" },
  { label: "OPP CH4", key: "dispPenCh4" },

  // FROM DOWNSTREAM
  { label: "dsPRECh1", key: "dsPRECh1" },
  { label: "dsPRECh2", key: "dsPRECh2" },
  { label: "dsPRECh3", key: "dsPRECh3" },
  { label: "dsPRECh4", key: "dsPRECh4" },
];


// WEBPACK FOOTER //
// ./src/data/headers_CSV.js